import type { BlankSlot, ReorderItem, ReadingQuestion, ReadingAnswer, QuestionAnswer, PassageAnswer } from '@examing/types';
export interface AnswerKeySource {
  type?: string; blanks?: BlankSlot[]; reorderItems?: ReorderItem[]; correctOrder?: string[];
  subQuestions?: unknown[];
}
export function correctBlanksValue(blanks?: BlankSlot[]): Record<string, string> {
  return Object.fromEntries((blanks ?? []).filter((blank) => blank?.id).map((blank) => [blank.id, blank.acceptedAnswers?.[0] ?? '']));
}
export function correctReorderValue(items?: ReorderItem[], correctOrder?: string[]): string[] {
  const known = new Set((items ?? []).map((item) => item.id));
  const ordered = (correctOrder ?? []).filter((id) => known.has(id));
  return [...ordered, ...(items ?? []).map((item) => item.id).filter((id) => !ordered.includes(id))];
}
export function correctPassageValue(subQuestions?: unknown[]): PassageAnswer {
  const value: PassageAnswer = {};
  for (const raw of subQuestions ?? []) {
    const question = raw as ReadingQuestion;
    if (!question?.id) continue;
    let answer: ReadingAnswer | undefined = question.correctAnswer;
    if (question.type === 'MATCHING') answer = Object.fromEntries((question.matchPairs ?? []).map((pair) => [pair.key, pair.value]));
    else if (question.type === 'FILL_IN_BLANKS' && question.blanks?.length) answer = correctBlanksValue(question.blanks);
    else if (question.type === 'SHORT_ANSWER') answer = question.acceptedAnswers?.[0] ?? answer;
    else if (!answer || (Array.isArray(answer) && !answer.length)) {
      const marked = (question.options ?? []).filter((option) => option.isCorrect === true).map((option) => option.id);
      answer = question.type === 'MULTIPLE_RESPONSE' ? marked : marked[0];
    }
    if (answer !== undefined) value[question.id] = answer;
  }
  return value;
}
export function correctValueFor(question: AnswerKeySource): QuestionAnswer {
  switch (question.type) {
    case 'FILL_IN_BLANKS': return correctBlanksValue(question.blanks);
    case 'REORDER': return correctReorderValue(question.reorderItems, question.correctOrder);
    case 'PASSAGE': return correctPassageValue(question.subQuestions);
    default: return '';
  }
}
